import React from 'react';
import {
  HiOutlineArrowRightOnRectangle,
  HiOutlineDocumentText,
  HiOutlineFolder,
  HiOutlineListBullet,
  HiOutlinePencilSquare,
  HiOutlinePlusCircle,
  HiOutlineSquares2X2,
} from 'react-icons/hi2';
import { NavLink } from 'react-router-dom';
import logo from '../assets/logo.png';
import SidebarMenu from './SidebarMenu';

const contentItems = [
  {
    title: 'Add Category',
    icon: HiOutlinePlusCircle,
    href: '/dashboard/blog-category',
  },
  {
    title: 'Category List',
    icon: HiOutlineListBullet,
    href: '/dashboard/blog-category-list',
  },
  {
    title: 'Add Blog',
    icon: HiOutlinePencilSquare,
    href: '/dashboard/blog',
  },
  {
    title: 'Blog List',
    icon: HiOutlineDocumentText,
    href: '/dashboard/blog-list',
  },
];

const Sidenavbar = ({ collapsed, onClose }) => {
  return (
    <aside className="app-sidebar" aria-label="Primary navigation">
      <div className="sidebar-brand">
        <NavLink to="/dashboard/dash_board" className="brand-link" onClick={onClose}>
          <img src={logo} alt="Event Planet" />
          <span>Event Planet</span>
        </NavLink>
      </div>

      <nav className="sidebar-nav">
        <span className="sidebar-section-label">Workspace</span>
        <NavLink
          className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
          to="/dashboard/dash_board"
          title="Dashboard"
          onClick={onClose}
        >
          <HiOutlineSquares2X2 aria-hidden="true" />
          <span className="hide-menu">Dashboard</span>
        </NavLink>

        <SidebarMenu
          title="Blog Management"
          icon={HiOutlineFolder}
          items={contentItems}
          collapsed={collapsed}
          onNavigate={onClose}
        />
      </nav>

      <div className="sidebar-footer">
        <NavLink className="sidebar-link" to="/dashboard/logout" title="Logout" onClick={onClose}>
          <HiOutlineArrowRightOnRectangle aria-hidden="true" />
          <span className="hide-menu">Logout</span>
        </NavLink>
      </div>
    </aside>
  );
};

export default Sidenavbar;
